export function formatCityState(city?: string | null, state?: string | null, zip?: string | null) {
	if (city && state) return `${city}, ${state} ${zip ?? ''}`;
	return `${city ?? ''}${state ?? ''} ${zip ?? ''}`.trim();
}

/**
 * Formats a number as currency (USD). Returns "0.00" for null/undefined/zero values.
 */
export function formatCurrency(amount: number | null | undefined): string {
	const value = amount ?? 0;
	return value.toLocaleString('en-US', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
}
